/** The status check needs the interval being chosen, or it cannot tell monthly to yearly from "same plan". */
export function checkStatusPath({ teamId, planId, interval }) {
  const query = `teamId=${encodeURIComponent(teamId)}&planId=${encodeURIComponent(planId)}`;
  return `/subscriptionPlans/checkStatus?${query}${interval ? `&interval=${encodeURIComponent(interval)}` : ''}`;
}
